import { Injectable } from '@angular/core';

import { PartnerSettings } from '../../interfaces';
import { AuthService } from './../auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class BaseSourceService {

  constructor(private authService: AuthService) { }

  public get hasScanner(): boolean {
    const {
      useTMT,
      useBotman,
      usePixalate,
      usePMPreBid,
      usePixalatePrebid,
      usePM,
      useGeoedge,
      botman_settings,
      useFraudlogix,
      use_media_guard,
      use_fraud_sensor,
    } = this.authService.partner as any as PartnerSettings;
    return Boolean(useTMT ||
      useBotman ||
      usePixalate ||
      usePMPreBid ||
      usePixalatePrebid ||
      usePM ||
      useGeoedge ||
      use_media_guard ||
      use_fraud_sensor ||
      useFraudlogix ||
      (botman_settings &&
        Object.keys(botman_settings).length &&
        (botman_settings.enable_postbid || botman_settings.enable_prebid))
    );
  }
}
